(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vb-faq-item"] && !Shopify.designMode) return;
  try {
    // Escape closes the open answer that holds focus and returns focus to its question.
  // Native <details> already handles Tab, Enter and Space; this is the only key it lacks.
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || event.defaultPrevented) return;
    const target = event.target instanceof Element ? event.target : null;
    const item = target?.closest('details.vb-faq-item[open]');
    if (!item) return;
    item.open = false;
    item.querySelector('summary')?.focus();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["vb-product-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vb-product-share')) {
    customElements.define(
      'vb-product-share',
      class extends HTMLElement {
        connectedCallback() {
          this.status = this.querySelector('[data-vb-share-status]');
          const canShare = typeof navigator.share === 'function';
          const native = this.querySelector('[data-vb-share-native]');
          if (native && canShare) native.hidden = false;
          this.addEventListener('click', (event) => {
            const btn = event.target instanceof Element ? event.target.closest('[data-vb-share]') : null;
            if (!btn) return;
            const kind = btn.getAttribute('data-vb-share');
            if (kind === 'copy') this.copy(this.dataset.copied);
            else if (kind === 'native') this.native();
            else if (kind === 'instagram') {
              if (canShare) this.native();
              else this.copy(this.dataset.insta);
            }
          });
        }

        data() {
          return { title: this.dataset.title, text: this.dataset.text, url: this.dataset.url };
        }

        native() {
          navigator.share?.(this.data()).catch(() => {});
        }

        copy(message) {
          const url = this.dataset.url || window.location.href;
          const done = () => this.say(message);
          if (navigator.clipboard?.writeText) {
            navigator.clipboard.writeText(url).then(done, () => this.fallbackCopy(url, done));
          } else {
            this.fallbackCopy(url, done);
          }
        }

        fallbackCopy(url, done) {
          const field = document.createElement('textarea');
          field.value = url;
          field.setAttribute('readonly', '');
          field.style.position = 'fixed';
          field.style.opacity = '0';
          document.body.append(field);
          field.select();
          try {
            document.execCommand('copy');
          } catch {}
          field.remove();
          done();
        }

        say(message) {
          if (!this.status || !message) return;
          this.status.textContent = message;
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            this.status.textContent = '';
          }, 4000);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
